export const ROUTE_CONFIG = {
	LOGIN: "/login",
	JOIN_SCENARIO: "/first-login",
	TFA: "/2fa",
	LOGOUT: "/logout",
	FORGOT_PASSWORD: "/forgot-password",
	ERROR_PAGE: "/error-page",
	ACCOUNT: "/app/account",
	COMPANY: "/app/company",
	USERS: "/app/users",
	USER_ROLES: "/app/users/user-roles",
	COMPANIES: "/app/companies",
	ANALYTICS: "/app/reports",
	ACCOUNTS: "/app/accounts",
	DASHBOARD: "/app/dashboard",
	COURSES: "/app/scenarios",
	INTRO_VIDEO_WIZARD: "/app/scenarios/edit/:id/intro-video",
	COMPANY_MANAGEMENT: "/app/company-management",
	TUTORIALS: "/app/tutorials",
	KPI_DASHBOARD: "/app/kpi-dashboard",
	MEDIA_PRESETS: "/app/settings/media-presets",
	MEDIA_COSTS: "/app/settings/media-costs",
	MEDIA_LIBRARY: "/app/media",
	EMAIL_OTP: "/email-otp",
	PRIVACY_POLICY: "/privacy-policy",
};

export const PUBLIC_PAGES_AFTER_LOGIN = [ROUTE_CONFIG.FORGOT_PASSWORD, ROUTE_CONFIG.PRIVACY_POLICY];
